import { useTranslation } from 'react-i18next';
import { UseFormRegisterReturn } from 'react-hook-form';
import { Box, Radio, Text } from '@mantine/core';

const TEMPLATE_TYPES = [
  {
    value: 'base',
    labelTranslation: 'templates:baseTemplate',
  },
  {
    value: 'attachment',
    labelTranslation: 'templates:attachmentTemplate',
  },
];

type Props = {
  templateTypeRadioProps: UseFormRegisterReturn;
};

export const TemplateTypeRadio = ({ templateTypeRadioProps }: Props) => {
  const { t } = useTranslation('templates');

  return (
    <Box sx={theme => ({ display: 'grid', gap: theme.other.spacing(2) })}>
      {TEMPLATE_TYPES.map(({ value, labelTranslation }) => (
        <Radio
          {...templateTypeRadioProps}
          key={value}
          value={value}
          label={
            <Text sx={{ display: 'block' }} span>
              {t(labelTranslation)}
            </Text>
          }
        />
      ))}
    </Box>
  );
};
